import { useState, useMemo, useCallback } from 'react';
import { format, subDays, startOfDay } from 'date-fns';

type Preset = 'today' | '7d' | '30d' | '90d' | '1y';

function presetToRange(preset: Preset): [Date, Date] {
  const today = startOfDay(new Date());
  switch (preset) {
    case 'today': return [today, today];
    case '7d':    return [subDays(today, 6), today];
    case '30d':   return [subDays(today, 29), today];
    case '90d':   return [subDays(today, 89), today];
    case '1y':    return [subDays(today, 364), today];
  }
}

export function useAdminDateRange(defaultPreset: Preset = '7d') {
  const [initial] = useState(() => presetToRange(defaultPreset));
  const [startDate, setStartDate] = useState<Date>(initial[0]);
  const [endDate, setEndDate] = useState<Date>(initial[1]);

  const queryParams = useMemo(
    () => `start_date=${format(startDate, 'yyyy-MM-dd')}&end_date=${format(endDate, 'yyyy-MM-dd')}`,
    [startDate, endDate]
  );

  const setRange = useCallback((start: Date, end: Date) => {
    setStartDate(start);
    setEndDate(end);
  }, []);

  return { startDate, endDate, setRange, queryParams };
}
